import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { getCurrentUserPsId } from '@app/auth/state/auth.selectors';
import { IRequester } from '@app/pages/cmms/interfaces/request.interfaces';
import { AuRoundAvatarModule } from '@app/shared/ui-components';
import {
	IAuComment,
	IAuCommentEditEvent,
} from '@app/shared/ui-components/au-comments/i-au.comment';
import { Store } from '@ngrx/store';

@Component({
	selector: 'entity-comment-item',
	imports: [
		MatIconModule,
		CommonModule,
		MatMenuModule,
		AuRoundAvatarModule,
		MatButtonModule,
	],
	templateUrl: './entity-comment-item.component.html',
	styleUrl: './entity-comment-item.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityCommentItemComponent {
	private readonly store$ = inject(Store);
	private userPsId = this.store$.selectSignal(getCurrentUserPsId);
	requester = input<IRequester[]>([]);
	comment = input<IAuComment>();

	deleteComment = output<string>();
	editComment = output<IAuCommentEditEvent>();

	sentByMe = computed(() => this.userPsId() === this.comment().author?.psId);
	canEdit = computed(() => this.sentByMe());

	commentAuthorName = computed<string>(() => {
		const author = this.comment().author;
		if (!author) {
			return 'Anonymous';
		}
		return author.displayName;
	});

	commentAuthorAvatar = computed<string | null>(() => {
		const author = this.comment().author;

		if (!author) {
			return null;
		}

		return author.imageUrl;
	});

	isHtml(content: string): boolean {
		const regexForHTML = /^<([A-Za-z][A-Za-z0-9]*)\b[^>]*>/;
		return regexForHTML.test(content);
	}
}
